/**
 * 获取URL参数的工具函数
 * @param name 参数名
 * @returns 参数值或null
 */
export function getUrlParameter(name: string): string {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name) ?? "2";
}

/**
 * 根据scene参数获取对应的图片URL
 * @returns 图片URL
 */
export function getImageUrlByScene(): string {
  const scene = getUrlParameter("scene");

  switch (scene) {
    case "1": // 官网
      return "https://img1.guanaitong.com/grus-gfs/product/giveapp-mgr/by-days/2025-06-05/3465538135b525e321c41ad2c1fc6f50.png";
    case "2": // 企业福利商城
      // 如果scene=2需要使用不同的图片，请修改这里的URL
      return "https://img1.guanaitong.com/grus-gfs/product/giveapp-mgr/by-days/2025-06-05/b6b5181102296daae7b7487163fb4966.jpeg";
    default:
      // 默认使用原有图片
      return "https://img1.guanaitong.com/grus-gfs/product/giveapp-mgr/by-days/2025-06-05/3465538135b525e321c41ad2c1fc6f50.png";
  }
}

export function getImageUrlBySticky(): string {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("sticky") ?? "0";
}

export function getInputMessageByUrl(): string {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("msg") ?? "";
}

/**
 * 获取所有URL参数
 * @returns 包含所有URL参数的对象
 */
export function getAllUrlParameters(): Record<string, string> {
  const urlParams = new URLSearchParams(window.location.search);
  const params: Record<string, string> = {};

  urlParams.forEach((value, key) => {
    params[key] = value;
  });

  return params;
}

/**
 * 检查URL中是否存在指定参数
 * @param name 参数名
 * @returns 是否存在该参数
 */
export function hasUrlParameter(name: string): boolean {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has(name);
}
